/**
 * Adresses des fichiers de public/assets (modèles, sons, textures). Leurs noms sont fixes : nginx les sert en
 * « no-cache » (revalidation, 304 s'ils n'ont pas changé). La révision ne sert qu'à contourner les copies déjà
 * en cache sous l'ancienne règle (7 jours, avant 2026-10-03) ; inutile de l'incrémenter à chaque changement.
 */
export const ASSET_REVISION = 2;

export function assetUrl(path: string): string {
  return `${import.meta.env.BASE_URL}assets/${path}?v=${ASSET_REVISION}`;
}
